let tracking = {
    addTrackingParameters: function(url) {

        let first = getWithExpiry(keys.first);
        let last = getWithExpiry(keys.last);
        let sg = getWithExpiry(keys.sgTracking);

        if(first) {
            url = addParameter(url, 'landing', first);
        }

        if(last) {
            url = addParameter(url, 'referer', last);
        }

        if(sg) {
            url = addParameter(url, sg.name, sg.value);
        }

        return url;
    }
}

let keys = {
    first: 'tracking.first',
    last: 'tracking.last',
    sgTracking: 'tracking.sg'
}

export default ({app}, inject) => {

    app.context.$tracking = tracking;
    inject('tracking', tracking);

    // do the first / last page tracking
    app.router.afterEach((to, from) => {

        if(!to.path.includes('out')) {
            if(!getWithExpiry(keys.first)) {
                setWithExpiry(keys.first, to.path);
            }
            setWithExpiry(keys.last, to.path);
        }
    });

    var searchParams = new URLSearchParams(window.location.search);

    if(searchParams.has('gclid')) {
        setWithExpiry(keys.sgTracking, {
            name: 'gclid', value: searchParams.get('gclid')
        });
    }
    else if(searchParams.has('sgid')) {
        setWithExpiry(keys.sgTracking, {
            name: 'sgid', value: searchParams.get('sgid')
        });
    }
}

function setWithExpiry(key, value, ttl = null) {

    if(ttl == null) {
        // 12 hour
        ttl = 1000 * 3600 * 12;
    }

    setObject(key, {
        value: value,
        expiry: new Date().getTime() + ttl
    });
}

function getWithExpiry(key) {
    const itemRaw = localStorage.getItem(key);

    // if the item doesn't exist, return null
    if (!itemRaw) {
        return null;
    }

    const item = JSON.parse(itemRaw);

    if (new Date().getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
    }

    return item.value;
}

function setObject(key, object) {
    localStorage.setItem(key, JSON.stringify(object));
}

function addParameter(url, key, value) {
    return addParameterHelper(url, key + '=' + value);
}

function addParameterHelper(url, parameterString) {
    if(url.includes('?')) {
        url += '&';
    }
    else {
        url += '?';
    }

    return url + parameterString;
}
